export let apiUrl = process.env.REACT_APP_HOST_API;
export let atombo1Url = process.env.REACT_APP_ATOMBO_HOST_API;

export let apiCredentials = {
    clientSecret: process.env.REACT_APP_SECRET_API,
    clientID    : process.env.REACT_APP_CLIENT_ID_API,
};

export let twoFactorConfigEnabled = process.env.REACT_APP_TWO_FACTOR_ENABLED;